type MetaWidthAttributes = Record<string, string>;
type MetaMap = Record<string, MetaWidthAttributes>;
export type MetaProperties = [string, string][];

function addMetaTagWithName(attributeName: string, attributeValue: string) {
  const tag = document.createElement('meta');
  tag.setAttribute(attributeName, attributeValue);
  document.head.appendChild(tag);
  return tag;
}

function getMetaTagWithName(attributeName: string, attributeValue: string) {
  let tag = document.querySelector(`meta[${attributeName}="${attributeValue}"]`);
  if (!tag) {
    tag = addMetaTagWithName(attributeName, attributeValue);
  }
  return tag;
}

export function updateMetaTags(metaMap: MetaMap) {
  Object.entries(metaMap).forEach(([name, attributes]) => {
    const tag = getMetaTagWithName('name', name);
    Object.entries(attributes).forEach(([attribute, value]) => tag.setAttribute(attribute, value));
  });
}

export function setOpenGraphProperties(properties: MetaProperties) {
  // remove all og tags
  document.querySelectorAll('meta[property^="og"]').forEach(tag => document.head.removeChild(tag));
  // add new ones
  properties.forEach(([property, value]) => {
    addMetaTagWithName('property', property).setAttribute('content', value);
  });
}

export function updateOpenGraphProperties(properties: MetaProperties) {
  properties.forEach(([property, value]) => {
    getMetaTagWithName('property', property).setAttribute('content', value);
  });
}

export function setCanonicalUrl(url: string) {
  let tag = document.querySelector(`link[rel="canonical"]`);
  if (!tag) {
    tag = document.createElement('link');
    tag.setAttribute('rel', 'canonical');
    document.head.appendChild(tag);
  }
  tag.setAttribute('href', url);
  return tag;
}
